import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { CityDesktopRouter } from "./common/routers/CityDesktopRouter"
import { CityMobileRouter } from "./common/routers/CityMobileRouter"
import { EquipmentContextProvider } from "./modules/equipment/contexts/EquipmentContext/EquipmentContext.provider"
import { HorizontalSigningContextProvider } from "./modules/horizontalSigning/contexts/HorizontalSigningContext"
import { VerticalSigningContextProvider } from "./modules/verticalSigning/contexts/VerticalSigningContext"

export function L2rAppCity() {

    const isMobile = useIsMobileDevice()

    return (
        <VerticalSigningContextProvider>
            <HorizontalSigningContextProvider>  
                <EquipmentContextProvider>
                    {isMobile ? <CityMobileRouter /> : <CityDesktopRouter />}
                </EquipmentContextProvider>
            </HorizontalSigningContextProvider>
        </VerticalSigningContextProvider>
    )
}
